import { Link } from "react-router-dom";
import { DiscoverButton } from "./../../index";

const VersionCard = ({ title, version, onClick }) => {
  return (
    <Link className="versionCard" to={version} onClick={onClick}>
      <p className="vTitle">{title}</p>
      <DiscoverButton />
    </Link>
  );
};

export default VersionCard;
